import AriaLabel from "@mobi/components/AriaLabel"
import Text from "@mobi/ds/components/Text"

import "./style.scss"

const CardFooter = () => (
  <div className="cardFooter">
    <Text as="p" className="cardFooter__title">
      Você também pode entrar em contato com o Itaú Imobfone:
    </Text>
    <AriaLabel ariaText="Capitais e regiões metropolitanas: 4004 7051">
      <Text as="p" className="cardFooter__text--strong" aria-hidden="true">
        Capitais e regiões metropolitanas
      </Text>
      <Text as="p" className="cardFooter__text" aria-hidden="true">
        4004 7051
      </Text>
    </AriaLabel>

    <AriaLabel ariaText="Demais localidades: 0300 789 7051 (de segunda à sexta, das 8 horas às 22 horas)">
      <Text as="p" className="cardFooter__text--strong" aria-hidden="true">
        Demais localidades
      </Text>
      <Text as="p" className="cardFooter__text" aria-hidden="true">
        0300 789 7051 (De segundas à sexta, das 08h às 22h).
      </Text>
    </AriaLabel>
  </div>
)

export default CardFooter
